import './scss/index.scss';
import { dcFactory } from 'dc';
import CookieBarComponent from './js/cookie-bar.component';

dcFactory.register(CookieBarComponent);
